import {
  Question,
  QuestionProps,
  Section,
  Heading,
  QuestionType,
  SingleChoiceQuestion,
  MultipleChoiceQuestion,
  FillInBlankQuestion,
  MatchingQuestion,
  EssayQuestion,
} from '@module/form';
import { AiEntity } from '../json-to-entity';
import { AiChangeResourceType } from '@module/ai';

export interface AiEntityToJsonConverterInput {
  entity: AiEntity;
  itemType: AiChangeResourceType;
}

/**
 * Convert domain entities into JSON props for persistence.
 * Used when saving AI resource change records.
 */
export class AiEntityToJsonConverter {
  public static execute(input: AiEntityToJsonConverterInput): string {
    const { entity, itemType } = input;

    switch (itemType) {
      case AiChangeResourceType.Question:
        return this.serializeQuestion(entity as Question<QuestionProps>);
      case AiChangeResourceType.Section:
        return this.serializeSection(entity as Section);
      case AiChangeResourceType.Heading:
        return this.serializeHeading(entity as Heading);
      default:
        return JSON.stringify({});
    }
  }

  private static serializeQuestion(q: Question<QuestionProps>): string {
    switch (q.type) {
      case QuestionType.SingleChoice: {
        const singleChoiceQuestion = q as SingleChoiceQuestion;

        return JSON.stringify(singleChoiceQuestion.toJsonV2());
      }
      case QuestionType.MultipleChoice: {
        const multipleChoiceQuestion = q as MultipleChoiceQuestion;

        return JSON.stringify(multipleChoiceQuestion.toJsonV2());
      }
      case QuestionType.FillInBlank: {
        const fillInBlankQuestion = q as FillInBlankQuestion;

        return JSON.stringify(fillInBlankQuestion.toJsonV2());
      }
      case QuestionType.Matching: {
        const matchingQuestion = q as MatchingQuestion;

        return JSON.stringify(matchingQuestion.toJsonV2());
      }
      case QuestionType.Essay: {
        const essayQuestion = q as EssayQuestion;

        return JSON.stringify(essayQuestion.toJsonV2());
      }
    }
  }

  private static serializeSection(s: Section): string {
    return JSON.stringify(s.toJsonObject());
  }

  private static serializeHeading(h: Heading): string {
    return JSON.stringify(h.toJsonObject());
  }
}
